import { render, staticRenderFns } from "./Salary.vue?vue&type=template&id=568c935e&scoped=true"
import script from "./Salary.vue?vue&type=script&lang=js"
export * from "./Salary.vue?vue&type=script&lang=js"
import style0 from "./Salary.vue?vue&type=style&index=0&id=568c935e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c935e",
  null
  
)

export default component.exports